import { render, staticRenderFns } from "./ClientSelection.vue?vue&type=template&id=374018da"
import script from "./ClientSelection.vue?vue&type=script&lang=js"
export * from "./ClientSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports